import { render, staticRenderFns } from "./Vendassubgrupos.vue?vue&type=template&id=06d46535&"
import script from "./Vendassubgrupos.vue?vue&type=script&lang=js&"
export * from "./Vendassubgrupos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports